import Tooltip from 'tooltip.js'

export const settings = {
  selector: '.js-building-services',
  item: '.js-building-services-item',
  tooltipEl: '.js-building-services-tooltip'
}

/**
 * Function initializes all elements in page.
 */
export default function initAll() {
  let elements = document.querySelectorAll( settings.selector )
  Array.from( elements ).forEach(( element ) => {
    init( element )
  })
}

/**
 * Function initializes single element.
 * @param {DOMNode} element
 */
export function init( element ) {
  const items = element.querySelectorAll( settings.item )
  Array.from( items ).forEach(( item ) => {
    initTooltip( item )
  })
}

/**
 * Init tooltips.
 *
 * @param {DOMNode} element
 */
function initTooltip( element ) {
  const tooltipElement = element.querySelector( settings.tooltipEl )
  const tooltip = tooltipElement.dataset.tooltip
  new Tooltip( tooltipElement, {
    placement: 'top',
    title: tooltip
  })
}
